import React from 'react'
import Typography from '@mui/material/Typography';

function Save({ widgetStyle, widgetProps }) {
    return (
        <Typography 
            sx={[
                widgetStyle ?? {}, 
                widgetProps.linkColor && {a: { color: widgetProps.linkColor }},
                widgetProps.textDecoration && {a: { textDecoration: widgetProps.textDecoration }}
            ]} 
            dangerouslySetInnerHTML={{ __html: widgetProps.data ?? 'Text Widget' }} 
        />
    )
}

export default React.memo(Save);